import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onLogin(username, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 relative overflow-hidden">
      
      {/* Background ambient glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="w-full max-w-md relative z-10">
        {/* Logo Section */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-surface-container border border-outline-variant/30 rounded-3xl mb-6 shadow-2xl relative group">
            <div className="absolute inset-0 bg-primary/10 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <span className="material-symbols-outlined text-5xl text-primary drop-shadow-[0_0_15px_rgba(249,189,34,0.3)]">sports_soccer</span>
          </div>
          <h1 className="text-4xl font-black font-lexend text-on-background tracking-tight mb-2">Eclipse FC</h1>
          <p className="font-manrope text-stone-400 font-bold uppercase tracking-widest text-sm">System Authentication</p>
        </div>

        {/* Login Card */}
        <div className="bg-surface-container/80 backdrop-blur-xl border border-outline-variant/30 rounded-3xl p-8 shadow-2xl">
          {error && (
            <div className="mb-6 bg-error/10 border border-error/20 flex items-center gap-3 px-4 py-3 rounded-xl animate-fadeIn">
              <span className="material-symbols-outlined text-error text-xl">error</span>
              <p className="text-error font-manrope text-sm font-bold">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Username Field */}
            <div className="space-y-2">
              <label className="block text-stone-400 font-manrope text-[11px] font-bold uppercase tracking-widest pl-1">
                Operator ID
              </label>
              <div className="relative group">
                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-stone-500 group-focus-within:text-primary transition-colors">person</span>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  className="w-full bg-background border border-outline-variant/50 rounded-xl pl-12 pr-4 py-4 text-on-background font-manrope placeholder:text-stone-600 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all shadow-inner"
                  required
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="space-y-2">
              <label className="block text-stone-400 font-manrope text-[11px] font-bold uppercase tracking-widest pl-1">
                Access Code
              </label>
              <div className="relative group">
                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-stone-500 group-focus-within:text-primary transition-colors">lock</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full bg-background border border-outline-variant/50 rounded-xl pl-12 pr-4 py-4 text-on-background font-manrope placeholder:text-stone-600 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all shadow-inner"
                  required
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full mt-8 bg-primary hover:bg-primary/90 text-on-primary font-lexend font-bold uppercase tracking-widest py-4 rounded-xl transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_0_20px_rgba(249,189,34,0.2)] hover:shadow-[0_0_25px_rgba(249,189,34,0.4)] flex justify-center items-center gap-2"
            >
              {loading ? (
                <>
                  <span className="material-symbols-outlined animate-spin text-xl">progress_activity</span>
                  Authenticating...
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined text-xl">login</span>
                  Initialize Session
                </>
              )}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="text-center mt-8 space-y-2">
          <p className="text-stone-500 font-manrope text-xs font-bold flex items-center justify-center gap-1.5">
            <span className="material-symbols-outlined text-[14px]">shield</span>
            Encrypted Connection Established
          </p>
          <p className="text-stone-600 font-manrope text-[10px] uppercase tracking-widest">
            v2.4.0 • Eclipse FC Systems
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
